<template>
    <v-tooltip
        right
    >
        <template
            v-slot:activator="{ on, attrs }"
        >
            <v-chip
                :color="statusColor"
                v-on="on"
                v-bind="attrs"
                dark
            >
                <v-icon>
                    {{ statusIcon }}
                </v-icon>
            </v-chip>
        </template>
        <div>
            {{ statusText }}
        </div>
    </v-tooltip>
</template>

<script>
export default {
    props: {
        status: {
            type: Number,
            required: true,
        },
    },
    computed: {
        statusText() {
            switch (this.status) {
                case 0:
                case 1:
                    return this.$t('services.status.new');
                case 2:
                    return this.$t('services.status.pending');
                case 3:
                    return this.$t('services.status.confirmed');
                case -1:
                    return this.$t('services.status.declined');
                case -2:
                    return this.$t('services.status.declinedOther');
                default:
                    return '';
            }
        },
        statusColor() {
            switch (this.status) {
                case 2:
                    return 'orange';
                case 3:
                    return 'green';
                case -1:
                case -2:
                    return 'red';
            }

            return 'primary';
        },
        statusIcon() {
            switch (this.status) {
                case 2:
                    return 'mdi-check';
                case 3:
                    return 'mdi-check-all';
                case -1:
                case -2:
                    return 'mdi-close';
            }

            return 'mdi-alert-decagram';
        },
    }
}
</script>
